'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createMuiTheme = {};

exports.__exports = createMuiTheme;
